'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getModel;
function getModel(model, state) {
  return typeof model === 'function' && state ? model(state) : model;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-form/lib/utils/get-model.js
// module id = 59
// module chunks = 0